import {
  ROUTE_SOCIAL_USERS_TAB,
  ROUTE_SOCIAL_FRIENDS_TAB,
  ROUTE_SOCIAL_FRIENDS,
  ROUTE_SOCIAL_GROUPS_TAB,
  ROUTE_SOCIAL_MESSAGES_TAB,
  ROUTE_SOCIAL_USERS,
  ROUTE_SOCIAL_EXPERTS,
} from "Consts/publicRoutes";

export const SIDENAV_SOCIAL_SECTION = {
  text: "Social",
  userRoute: ROUTE_SOCIAL_FRIENDS,
  restrictedRoute: ROUTE_SOCIAL_USERS,
};

export const SIDENAV_SOCIAL_FRIENDS_ROUTE = {
  text: "Friends",
  route: ROUTE_SOCIAL_FRIENDS_TAB,
};

export const SIDENAV_SOCIAL_CLIENTS_ROUTE = {
  text: "Users",
  route: ROUTE_SOCIAL_USERS_TAB,
};

export const SIDENAV_SOCIAL_GROUPS_ROUTE = {
  text: "Groups",
  route: ROUTE_SOCIAL_GROUPS_TAB,
};

export const SIDENAV_SOCIAL_MESSAGES_ROUTE = {
  text: "Messages",
  route: ROUTE_SOCIAL_MESSAGES_TAB,
};

export const SIDENAV_SOCIAL_NOTIFICATIONS_ROUTE = {
  text: "Notifications",
  route: { name: "social.notifications" },
};

export const SIDENAV_SOCIAL_COACHES_ROUTE = {
  text: "Experts",
  route: { name: ROUTE_SOCIAL_EXPERTS },
};
